import { render } from "./OfficeOrdemCompraTab.vue?vue&type=template&id=04800cc8&scoped=true&ts=true"
import script from "./OfficeOrdemCompraTab.vue?vue&type=script&lang=ts"
export * from "./OfficeOrdemCompraTab.vue?vue&type=script&lang=ts"

import "./OfficeOrdemCompraTab.vue?vue&type=style&index=0&id=04800cc8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04800cc8"]])

export default __exports__